import { gql } from 'graphql-request';

const htlAdBlockFragment = gql`
  fragment AcfHtlAdBlockFragment on AcfHtlAdBlock {
    site
    unit
  }
`;
export default htlAdBlockFragment;